import { useEffect, useState, useRef, useMemo } from 'react';
// form
import { useForm, Controller } from 'react-hook-form';
// @mui
import { DatePicker, LoadingButton } from '@mui/lab';
import {
  Autocomplete,
  Button,
  Card,
  Chip,
  Grid,
  Stack,
  TextField,
  Container,
  Checkbox,
} from '@mui/material';
// routes
import { PATH_DASHBOARD } from 'src/routes/paths';
// @types
// components
import Iconify from 'src/components/Iconify';
import { useStore } from 'src/stores/store';
import { observer } from 'mobx-react-lite';
import useLocales from 'src/hooks/useLocales';

import HeaderBreadcrumbs from 'src/components/HeaderBreadcrumbs';
import useSettings from 'src/hooks/useSettings';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import ReactToPrint from 'react-to-print';
import Loader from 'src/components/loader/Loader';
import Page from 'src/components/Page';
import LocalizDatePicker from 'src/sections/common/LocalizDatePicker';
import { IRentPaymentSearchParam } from 'src/@types/Choqorak/MainTables/RentPayment.ts/RentPayment';
import { RentPaymentTableView } from './RentPaymentTableView';

// ----------------------------------------------------------------------

export default observer(function StatisticalReportIndex() {
  const { commonDropdown, ChoqorakCommonDropdown } = useStore();

  const { loadBlockeDDL, BlockOption, loadFloorDDL, FloorOption, loadShopDDL, ShopOption } =
    ChoqorakCommonDropdown;
  const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
  const checkedIcon = <CheckBoxIcon fontSize="small" />;
  const [filterButtonClicked, setFilterButtonClicked] = useState(false);
  const [isloading, setIsloading] = useState(false);
  const [branch, setBranch] = useState<any>([]);
  const [expenseType, setExpenseType] = useState<any>([]);
  const { themeStretch } = useSettings();
  const { translate } = useLocales();

  // const { loadExpenseStatisticalReport, ExpenseStatisticalReportDetails } = ExpenseReportsStore;
  const {} = commonDropdown;
  const handleChangeBranch = (event: any, newValue: any[]) => {
    const selectedOptionValues = newValue.map((value) => value.value);
    setBranch(selectedOptionValues);
  };

  const handleChangeExpenseType = (event: any, newValue: any[]) => {
    const selectedOptionValues = newValue.map((value) => value.value);
    setExpenseType(selectedOptionValues);
  };

  let componentRef = useRef<any>(null);
  const methods = useForm<IRentPaymentSearchParam>({
    // defaultValues,
  });

  const { setValue, watch, control, reset } = methods;

  const val = watch();

  // const defaultValues = useMemo<IExpenseReportParam>(
  //   () => ({
  //     fromDate: new Date(),
  //     toDate: new Date(),
  //   }),
  //   []
  // );

  // useEffect(() => {
  //   loadBranchDDL();
  //   loadExpenseTypeDropdown();
  //   reset(defaultValues);
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [reset, defaultValues, loadUserDropdown]);

  const Search = (e: any) => {
    e.preventDefault();
    setFilterButtonClicked(!filterButtonClicked);
    setIsloading(true);
    // loadExpenseStatisticalReport({
    //   branchIds: branch,
    //   expenseTypeIds: expenseType,
    //   fromDate: val.fromDate,
    //   toDate: val.toDate,
    // }).then((rest) => {
    //   setTimeout(() => {
    //     setIsloading(false);
    //   }, 500);
    // });
  };
  // useEffect(() => {}, [ExpenseStatisticalReportDetails, isloading]);
  useEffect(() => {
    loadBlockeDDL();
    loadFloorDDL();
    if (val.floorId) {
      loadShopDDL(val.floorId);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [val.floorId]);

  return (
    <Page title={translate('Report.ReportTitle')}>
      <Container maxWidth={themeStretch ? false : 'lg'}>
        <HeaderBreadcrumbs
          heading={translate('Report.ExpenseReport')}
          links={[{ name: translate('Report.Dashboard'), href: PATH_DASHBOARD.root }]}
        />

        <Grid container spacing={3}>
          <Grid item xs={12} md={12}>
            <Card sx={{ padding: '30px' }}>
              <Grid container spacing={2}>
                <Grid item xs={12} md={3}>
                  <LocalizDatePicker
                    name="Date"
                    label={translate('Employee.date')}
                    control={control}
                    showAsterisk={true}
                    views={['month', 'year']}
                  />
                </Grid>
                <Grid item xs={12} md={3}>
                  <Controller
                    name="blockId"
                    control={control}
                    render={({ field, fieldState: { error } }) => (
                      <Autocomplete
                        freeSolo
                        options={BlockOption.map((option: any) => option)}
                        value={field.value}
                        getOptionLabel={(option) => option.text}
                        onChange={(event, newValue) => {
                          handleChangeBranch(event, newValue);
                          field.onChange(newValue);
                        }}
                        renderTags={(value, getTagProps) =>
                          value.map((option, index) => (
                            <Chip
                              {...getTagProps({ index })}
                              key={option.value}
                              size="small"
                              label={option.text}
                            />
                          ))
                        }
                        // renderOption={(props, option, { selected }) => (
                        //   <li {...props}>
                        //     <Checkbox
                        //       icon={icon}
                        //       checkedIcon={checkedIcon}
                        //       style={{ marginRight: 8 }}
                        //       checked={selected}
                        //     />
                        //     {option.text}
                        //   </li>
                        // )}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            sx={{ marginBottom: '20px' }}
                            size="medium"
                            label={translate('Report.Block')}
                            error={!!error}
                            helperText={error?.message}
                          />
                        )}
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={12} md={3}>
                  <Controller
                    name="floorId"
                    control={control}
                    render={({ field, fieldState: { error } }) => (
                      <Autocomplete
                        freeSolo
                        options={FloorOption.map((option: any) => option)}
                        value={field.value}
                        getOptionLabel={(option) => option.text}
                        onChange={(event, newValue) => {
                          // handleChangeBranch(event, newValue);
                          field.onChange(newValue);
                          setValue('floorId', newValue.value);
                        }}
                        renderTags={(value, getTagProps) =>
                          value.map((option, index) => (
                            <Chip
                              {...getTagProps({ index })}
                              key={option.value}
                              size="small"
                              label={option.text}
                            />
                          ))
                        }
                        // renderOption={(props, option, { selected }) => (
                        //   <li {...props}>
                        //     <Checkbox
                        //       icon={icon}
                        //       checkedIcon={checkedIcon}
                        //       style={{ marginRight: 8 }}
                        //       checked={selected}
                        //     />
                        //     {option.text}
                        //   </li>
                        // )}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            sx={{ marginBottom: '20px' }}
                            size="medium"
                            label={translate('Report.Floor')}
                            error={!!error}
                            helperText={error?.message}
                          />
                        )}
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={12} md={3}>
                  <Controller
                    name="shopId"
                    control={control}
                    render={({ field, fieldState: { error } }) => (
                      <Autocomplete
                        // disableCloseOnSelect
                        freeSolo
                        options={ShopOption.map((option: any) => option)}
                        value={field.value}
                        getOptionLabel={(option) => option.text}
                        onChange={(event, newValue) => {
                          handleChangeBranch(event, newValue);
                          field.onChange(newValue);
                        }}
                        renderTags={(value, getTagProps) =>
                          value.map((option, index) => (
                            <Chip
                              {...getTagProps({ index })}
                              key={option.value}
                              size="small"
                              label={option.text}
                            />
                          ))
                        }
                        // renderOption={(props, option, { selected }) => (
                        //   <li {...props}>
                        //     <Checkbox
                        //       icon={icon}
                        //       checkedIcon={checkedIcon}
                        //       style={{ marginRight: 8 }}
                        //       checked={selected}
                        //     />
                        //     {option.text}
                        //   </li>
                        // )}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            sx={{ marginBottom: '20px' }}
                            size="medium"
                            label={translate('Report.Shop')}
                            error={!!error}
                            helperText={error?.message}
                          />
                        )}
                      />
                    )}
                  />
                </Grid>
              </Grid>

              <Stack direction="row" spacing={1.5} sx={{ mt: 3 }}>
                <LoadingButton
                  size="small"
                  variant="contained"
                  onClick={Search}
                  startIcon={<Iconify icon="eva:search-fill" />}
                >
                  {translate('Report.Filter')}
                </LoadingButton>

                <ReactToPrint
                  trigger={() => (
                    <Button
                      size="small"
                      variant="contained"
                      color="warning"
                      startIcon={<Iconify icon="eva:printer-outline" />}
                    >
                      {translate('Report.Print')}
                    </Button>
                  )}
                  content={() => componentRef.current}
                  pageStyle="print"
                />

                <Button
                  size="small"
                  variant="contained"
                  color="error"
                  startIcon={<Iconify icon="eva:refresh-outline" />}
                  onClick={() => {
                    // ExpenseStatisticalReportDetails!.report!.length = 0;
                    setFilterButtonClicked(!filterButtonClicked);
                  }}
                >
                  {translate('Report.Reset')}
                </Button>
              </Stack>
            </Card>
          </Grid>

          <Grid item xs={12} md={12}>
            {isloading ? (
              <Loader />
            ) : (
              <RentPaymentTableView
                ref={componentRef}
                filterButtonClicked={filterButtonClicked}
                // StatisticalReportDetails={ExpenseStatisticalReportDetails}
              />
            )}
          </Grid>
        </Grid>
      </Container>
    </Page>
  );
});
